import { render, staticRenderFns } from "./ProblemBlock.vue?vue&type=template&id=3660e098&scoped=true&"
import script from "./ProblemBlock.vue?vue&type=script&lang=js&"
export * from "./ProblemBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProblemBlock.vue?vue&type=style&index=0&id=3660e098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3660e098",
  null
  
)

export default component.exports